import React, { useRef, useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioDetalhadoPorTransportador({ dadosRelatorio, btnVoltar, filtros }) {
    const { session, setupVariavel } = useAuth();
    //Referencia do relatorio para impressão pdf
    const refRelatorio = useRef(null);
    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetas = [
        { value: `Nº ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "item_Coleta", col: "4" },
        { value: "RAMO DE ATIVIDADE", objectValue: "segmento", col: "4" },
        { value: "REGIONAL", objectValue: "regional", col: "4" },

        { value: "MODALIDADE DE COLETA", objectValue: "tipo_Coleta", col: "6" },
        { value: "RESÍDUOS", objectValue: "residuo", col: "6" },

        { value: "COLETADO", objectValue: "volume", col: "4"},
        { value: "DATA/HORA DA COLETA", objectValue: "data_Coleta", formatDate: true, col: "4" },
        { value: "DATA/HORA DO RECEBIMENTO", objectValue: "data_Descarte", formatDate: true, col: "4" },

        { value: "STATUS", objectValue: "status_Coleta", col: "12" },

        { value: "CNPJ", objectValue: "cpfcnpj", col: "3" },
        { value: "NOME DO GERADOR", objectValue: "nome_Gerado", col: "9" },

        { value: "ENDEREÇO", objectValue: "local_Coleta", col: "12" },
    ];
    //Cabeçalhos para a listagem dos manivefestos de residuos por meio do cardRelatorio
    const headersManifestoDeResiduos = [

        { value: "IMPLEMENTO", objectValue: "implemento", col: "4" },
        { value: "QUANTIDADE DE IMPLEMENTOS", objectValue: "total_Implemento", col: "4" },
        { value: "PORCENTAGEM", objectValue: "porcentagem_Implemento", col: "4" },
    ];
    //Cabeçalhos para a listagem dos totalizadores de residuos solidos por meio do cardRelatorio
    const headersTotalizadoresResiduosSolidos = [
        { value: "MODALIDADE DE COLETA", objectValue: "modalidade", col: "6" },
        { value: "TIPO DE RESÍDUOS", objectValue: "tipoResiduo", col: "6" },

        { value: "INFORMADO", objectValue: "qtde_Informada_Contrado", col: "6" },
        { value: "GERADO", objectValue: "totalGerado", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores de ramo de atividade por meio do cardRelatorio
    const headersTotalizadoresRamoAtividade = [
        { value: "RAMO DE ATIVIDADE", objectValue: "ramoAtividade", col: "6" },
        { value: "N° DE GERADORES", objectValue: "numeroGeradore", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por numero de mtr por meio do cardRelatorio
    const headersTotalizadoresPorNMTR = [
        { value: "RANKING GERAL", objectValue: "ranking", col: "6" },
        { value: "TRANSPORTADOR", objectValue: "nome_TR", col: "6" },
        { value: `N° DE ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "total_MTR_TR", col: "6" },
        { value: "PERCENTUAL", objectValue: "percentual", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por status e modalidade usando o cardRelatorio
    const headersTotalizadoresPorStatusEModalidade = [
        { objectValue: "titulo", col: "6" },
        { objectValue: "quantidade", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por quantidade de transportadores por meio do cardRelatorio
    const headersTotalizadoresQuantidadeTransportadores = [
        { value: "RANKING GERAL", objectValue: "ranking", col: "6" },
        { value: "TRANSPORTADOR", objectValue: "nome_TR", col: "6" },
        { value: "QUANTIDADE", objectValue: "quantidade", col: "6" },
        { value: "PERCENTUAL", objectValue: "percentual", col: "6" },
    ];

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório detalhado por transportador",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório detalhado por transportador</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                        <div className='col-4'>
                            <p><span className="fw-bold">Status Coletas:</span> {filtros.status}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.transportadorId_selected
                                ?
                                <p><span className="fw-bold">Transportador:</span> {filtros.transportadorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Transportador:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>DADOS DO TRANSPORTADOR</h5>
                    <Row className='content-rel'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.transportador.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(dadosRelatorio.transportador.cnpj)}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.transportador.responsavel}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.transportador.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {mascaras.celularMask(dadosRelatorio.transportador.fone)}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {mascaras.cepMask(dadosRelatorio.transportador.cep)}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.transportador.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.transportador.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.transportador.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.transportador.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.transportador.numero}</div>
                    </Row>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Coletas</h5>
                    <CardRelatorio headers={headersColetas} items={dadosRelatorio.listaColetas} />
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>MANIFESTOS DE TRANSPORTE DE RESÍDUOS</h5>
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL DE {setupVariavel?.siglaDocumentoColeta}s LANÇADAS: </span>{dadosRelatorio.dadosManifestos[0]?.total_MTR}</p>
                        <h5 className='p-1 border-bottom fw-bold'>IMPLEMENTO RODOVIÁRIO</h5>
                        <CardRelatorio headers={headersManifestoDeResiduos} items={dadosRelatorio.dadosManifestos} />
                        <h5 className='p-1 border-bottom fw-bold'>STATUS</h5>
                        <div className=" row ">

                            <div className="p-1 col-4 border-bottom">
                                <p className=' '><span className="fw-bold">COLETADO: </span></p>

                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.total_Coletado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.porcentagem_Coletado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                <p><span className="fw-bold">RECEBIDO: </span></p>

                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.total_Baixado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.porcentagem_Baixado}
                            </div>
                        </div>

                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>RESÍDUOS SÓLIDOS</h5>
                        <CardRelatorio headers={headersTotalizadoresResiduosSolidos} items={dadosRelatorio.totalizadoresResiduosSolidos} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresResiduosSolidos[0]?.totalGerado}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADORES DE {setupVariavel?.siglaDocumentoColeta}S POR STATUS E MODALIDADE</h5>
                        <CardRelatorio headers={headersTotalizadoresPorStatusEModalidade} items={dadosRelatorio.totalizadoresStatusModalidade} />

                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADORES POR RAMO DE ATIVIDADE</h5>
                        <CardRelatorio headers={headersTotalizadoresRamoAtividade} items={dadosRelatorio.totalizadoresRamoAtividade} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRamoAtividade[0].total}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADOR POR N° DE {setupVariavel?.siglaDocumentoColeta}</h5>
                        <CardRelatorio headers={headersTotalizadoresPorNMTR} items={dadosRelatorio.totalizadoresRankingNumeroMTR} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRankingNumeroMTR[0]?.total_Geral}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADOR POR QUANTIDADE TRANSPORTADA</h5>
                        <CardRelatorio headers={headersTotalizadoresQuantidadeTransportadores} items={dadosRelatorio.totalizadoresRankingQuantidadeTransportadores} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRankingQuantidadeTransportadores[0] ? dadosRelatorio.totalizadoresRankingQuantidadeTransportadores[0]?.total_Geral : "0"}</p>
                    </div>
                </div>
            </div>
        </MainCard>
    )
}